import { useSelector } from 'react-redux';
import selectors from '../../selectors/selectors.js';
import React, { useEffect, useRef, useState } from 'react';
import { action } from '../../lib/actionHelpers.js';
import Filters from '../../components/Filters.js';
import MobileLoader from '../../components/svg/MobileLoader.js';

const topPaddingLoaderLimit = 80;
const topPaddingMax = 300;

const MobileFilterContainer = ({ children, className, onScroll, onReload, filters }) => {
  const query = useSelector(selectors.query);
  const filterValues = useSelector((state) => state.ui.filters);

  const [showFilters, setShowFilters] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [extended, setExtended] = useState(false);

  const draggingMeta = useRef({});
  const extendedMeta = useRef({});

  const touchState = useRef({});
  const containerRef = useRef({});

  const filtersHaveValues = (filters || []).filter((n) => !!filterValues[n.type || n.id]).length > 0;
  const doShowFilters = showFilters === true || filtersHaveValues;

  useEffect(() => {
    action('uiPatchFilters', { ['search']: '' });
    setShowFilters(false);
  }, [query]);

  const handleExtendedLogic = (n) => {
    if (onReload) {
      n = n > topPaddingMax ? topPaddingMax : n;
      n = n * 0.8;
      n = n < 0 ? 0 : n;
      if (n >= topPaddingLoaderLimit && !extended) {
        setExtended(true);
        extendedMeta.current = {
          start: new Date(),
          loaded: false,
          stopped: false,
        };
        onReload(() => {
          extendedMeta.current.loaded = true;
        });
        const extendedInterval = setInterval(() => {
          if (extendedMeta.current.stopped) {
            clearInterval(extendedInterval);
          }
          let diff = new Date() - extendedMeta.current.start;
          if ((diff > 1000 && extendedMeta.current.loaded) || diff > 6000) {
            extendedMeta.current.stopped = true;
            setExtended(false);
          }
        }, 100);
      }
    }
  };

  const handleTouchStart = (e) => {
    touchState.current.startX = e.touches[0].clientX;
    touchState.current.startY = e.touches[0].clientY;
    draggingMeta.current.startedWithFilters = showFilters;
    setDragging(true);
  };

  const handleTouchMove = (e) => {
    const x = e.touches[0].clientX;
    const y = e.touches[0].clientY;
    const yDiff = y - touchState.current.startY;

    if (draggingMeta.current.startedWithFilters) {
      let topPaddingHeight = yDiff > 0 && containerRef.current.scrollTop === 0 ? yDiff : 0;
      handleExtendedLogic(topPaddingHeight);
    }

    if (yDiff > 0 && containerRef.current.scrollTop === 0 && !showFilters) {
      setShowFilters(true);
    }
    touchState.current.lastX = x;
    touchState.current.lastY = y;
  };

  const handleTouchEnd = (e) => {
    setDragging(false);
    touchState.current = {};
    draggingMeta.current = {};
    handleExtendedLogic(0);
  };

  filters = filters || [{ type: 'search' }];

  return (
    <div className={'mobile-filter-container'}>
      <div className={`container-content ${className || ''} ${dragging ? 'dragging' : ''} ${extended ? 'extended' : ''}`} onScroll={onScroll} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} onTouchMove={handleTouchMove} ref={containerRef}>
        <div className={`top ${doShowFilters ? 'active' : ''}`}>
          <div className={'top-padding'}>
            <MobileLoader />
          </div>
          <Filters filters={filters} />
        </div>
        <div className={'mobile-filter-container-content'}>{children}</div>
      </div>
    </div>
  );
};

export default MobileFilterContainer;
